/**
 * Updates the navigation menu label with the provided user's first name.
 *
 * This function looks for a navigation menu item with the class `logged-in-menu`
 * and replaces its submenu toggle text with the given `name`,
 * if both the menu container and name are available.
 *
 * @param {string} loggedInText - The text to set for the logged-in menu item. Defaults to 'My Account'.
 */
const setupLoggedInMenu = (loggedInText = 'My Account') => {
	const menuContainer = document.querySelector('.wp-block-navigation-item.logged-in-menu');
	if (!menuContainer || !loggedInText) {
		return;
	}

	const toggleButton = menuContainer.querySelector('.wp-block-navigation-submenu__toggle');
	if (toggleButton) {
		toggleButton.textContent = loggedInText;
	}
};

export default setupLoggedInMenu;
